import { Component } from 'react';
import Raven from 'raven-js';
import UILayer from 'UIComponents/layer/UILayer';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
class LoadingComponent extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.error !== prevProps.error && this.props.error instanceof Error) {
      Raven.captureException(this.props.error);
    }
  }
  render() {
    return this.props.pastDelay ? /*#__PURE__*/_jsx(UILayer, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          position: 'fixed',
          // @ts-expect-error ts-migrate(2322) FIXME: Type '"1211"' is not assignable to type 'ZIndexPro... Remove this comment to see the full error message
          zIndex: URANUS_LAYER,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        children: /*#__PURE__*/_jsx(UILoadingOverlay, {})
      })
    }) : null;
  }
}
export default LoadingComponent;